var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnknown = function SvgUnknown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.75,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4724 10.9334H10.4951V10.7873C10.5114 10.5438 10.5925 10.349 10.7386 10.2192C11.1607 9.79708 11.4529 9.50487 11.6153 9.31006C11.7776 9.08279 11.875 8.79058 11.875 8.46591C11.875 7.41071 11.2581 6.875 10.0568 6.875C8.90422 6.875 8.25487 7.32955 8.125 8.2224C8.125 8.51461 8.2224 8.67695 8.41721 8.67695C8.61201 8.69318 8.87175 8.69318 9.16396 8.69318C9.21266 8.14123 9.50487 7.84903 10.0244 7.84903C10.5114 7.88149 10.7549 8.0763 10.7549 8.43344C10.7549 8.62825 10.6899 8.80682 10.5763 8.96916C10.4464 9.13149 10.3003 9.2776 10.138 9.40747C9.81331 9.66721 9.63474 9.89448 9.56981 10.0893C9.50487 10.3166 9.4724 10.5925 9.4724 10.9334ZM9.84578 11.4367C9.55357 11.4367 9.4237 11.5828 9.4237 11.8588V12.5568H10.5601V11.4367H9.84578Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnknown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "unknown.c060e0930eb94c991e5f7b3b746f2874.svg";